import { FileSizeValidation } from '../uploads/validation/validations/file-size-validation';
import { UploadValidator } from '../uploads/validation/upload-validator';
import { convertToBytes } from '../core/utils/convertToBytes';
import { FileTypeValidation } from '../uploads/validation/validations/file-type-validation';
import * as i0 from "@angular/core";
import * as i1 from "../core/config/settings.service";
import * as i2 from "../core/ui/toast.service";
import * as i3 from "../core/translations/translations.service";
export class AvatarValidator extends UploadValidator {
    constructor() {
        super(...arguments);
        this.DEFAULT_MAX_SIZE_MB = 5;
    }
    initValidations() {
        const validations = [
            new FileSizeValidation({ maxSize: convertToBytes(this.DEFAULT_MAX_SIZE_MB, 'MB') }, this.i18n),
            new FileTypeValidation({ types: ['image'] }, this.i18n),
        ];
        this.validations.push(...validations);
    }
}
AvatarValidator.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AvatarValidator_Factory() { return new AvatarValidator(i0.ɵɵinject(i1.Settings), i0.ɵɵinject(i2.Toast), i0.ɵɵinject(i3.Translations)); }, token: AvatarValidator, providedIn: "root" });
